// Shared metadata for the Print Delivery File feature.
// Mirrors backend DELIVERY_FILE_SECTIONS / CRITICAL_DOC_TYPES.
import {
  FileText, Receipt, ShieldCheck, Hash, Wrench, Package, FileCheck, FileBox, Sparkles,
} from "lucide-react";

export const DOC_TYPE_LABELS = {
  aadhar: "Aadhar Card",
  passport_photo: "Passport-size Photo",
  pan: "PAN Card",
  vin_photo: "Chassis VIN Photo",
  pdi_check_sheet: "PDI Check Sheet",
  vehicle_photo_front: "Vehicle · Front",
  vehicle_photo_left: "Vehicle · Left",
  vehicle_photo_right: "Vehicle · Right",
  vehicle_photo_rear: "Vehicle · Rear",
  tax_invoice: "Tax Invoice",
  tax_receipt: "Road Tax Receipt",
  hsrp_receipt: "HSRP Receipt",
  rc: "Registration Certificate (RC)",
  address_proof: "Address Proof",
  policy_doc: "Insurance Policy",
  spares_invoice: "Accessories Invoice",
  vas_pp_certificate: "PP Certificate",
  vas_pp_invoice: "PP Invoice",
  vas_amc_certificate: "AMC Certificate",
  vas_amc_invoice: "AMC Invoice",
  vas_rsa_policy: "RSA Policy",
  form_20: "Form 20",
  form_22: "Form 22",
  other: "Other Document",
  other_2: "Any Other Document 2",
};

export const SECTION_ICONS = {
  sales: FileText,
  accounts: FileCheck,
  insurance: ShieldCheck,
  registration: Receipt,
  hsrp: Hash,
  vas: Sparkles,
  pdi: Wrench,
  spares: Package,
  additional: FileBox,
};

export const CRITICAL_DOC_TYPES = ["aadhar", "passport_photo", "tax_invoice", "tax_receipt"];

export const isImage = (ct) => (ct || "").toLowerCase().startsWith("image/");
export const isPdf = (ct) => (ct || "").toLowerCase().includes("pdf");
